import { NavLink } from 'react-router-dom'
import { CalendarDays, ListTodo, Timer, Wallet } from 'lucide-react'
import { cn } from '../lib/utils'
import { useLanguage } from '../context/LanguageContext'

export const BottomNav = () => {
  const { t } = useLanguage()
  
  const navItems = [
    { path: '/', icon: CalendarDays, labelKey: 'nav.dailyImprovement' },
    { path: '/finanzas', icon: Wallet, labelKey: 'nav.finances' },
    { path: '/tareas', icon: ListTodo, labelKey: 'nav.tasks' },
    { path: '/ayuno', icon: Timer, labelKey: 'nav.fasting' },
  ]

  return (
    <nav className="bottom-nav z-40" data-testid="bottom-nav">
      <div className="flex items-center justify-around max-w-md mx-auto">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) => cn(
              'tab-button flex-1',
              isActive && 'active'
            )}
            data-testid={`nav-${item.labelKey}`}
          >
            {({ isActive }) => (
              <>
                <item.icon 
                  className={cn(
                    'w-6 h-6 mb-1 transition-colors',
                    isActive ? 'text-emerald-500' : 'text-muted-foreground'
                  )} 
                />
                <span className={cn(
                  'text-xs transition-colors',
                  isActive ? 'text-emerald-500 font-semibold' : 'text-muted-foreground'
                )}>
                  {t(item.labelKey)}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
